import React, { useState, useEffect } from 'react';
import { useImmer } from 'use-immer';
import { menuList } from 'data';
import { Icon } from 'components';
import { Line, H3, H2, Text, CenterRowDiv } from 'styles';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { find, cloneDeep } from 'lodash';
import { Spinner } from 'components/loading/Spinner';

import houseSensorService from 'services/house/house-sensor-service';
import containerSensorService from 'services/container/container-sensor-service';
import outdoorWeatherStationService from 'services/outdoor/outdoor-weather-station-service';
import containerCorridorService from 'services/container/container-corridor-service';
import houseCorridorService from 'services/house/house-corridor-service';
import outdoorWeatherKoreaService from 'services/outdoor/outdoor-weather-korea-service';

import * as S from './SideNavStyle';

export function SideNav(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const currentPath = location.pathname;
  // const currentMenu = menuList.find((menu) => currentPath.includes(menu.path));
  const [currentMenuData, updateCurrentMenu] = useImmer({
    currentMenu: menuList.find((menu) => currentPath.includes(menu.path))
  });
  const [loading, setLoading] = useState(false);

  const [openDeps, setOpenDeps] = useState({
    dep2: null,
    dep3: null,
    dep4: null,
  });

  useEffect(() => {
    let dep2 = 0;
    let dep3 = 0;

    for (let i = 0; i < currentMenuData.currentMenu.dep2.length; i++) {
      if (currentPath.includes(currentMenuData.currentMenu.dep2[i].path)) {
        dep2 = i;
        break;
      }
    }

    for (let i = 0; i < currentMenuData.currentMenu.dep2[dep2].dep3.length; i++) {
      if (currentPath.includes(currentMenuData.currentMenu.dep2[dep2].dep3[i].path)) {
        dep3 = i;
        break;
      }
    }

    setOpenDeps({
      dep2,
      dep3,
      dep4: null,
    });

    // if (currentMenuData.currentMenu?.path && !currentPath.includes(currentMenuData.currentMenu.path)) {
    //   setOpenDeps({
    //     dep2: 0,
    //     dep3: 0,
    //     dep4: null,
    //   });
    // } else if (currentMenuData.currentMenu?.dep2?.length > 0) {
    //   setOpenDeps({
    //     dep2: 0,
    //     dep3: 0,
    //     dep4: null,
    //   });
    // }
  }, [currentMenuData.currentMenu]);

  const toggleDep2 = (index) => {
    const newDep2 = openDeps.dep2 === index ? null : index;
    setOpenDeps((deps) => ({
      ...deps,
      dep2: newDep2,
      dep3: null,
      dep4: null,
    }));
  };

  const toggleDep3 = (index, dep3) => {
    setOpenDeps((deps) => ({
      ...deps,
      dep3: deps.dep3 === index ? null : index,
      dep4: null,
    }));
  };

  useEffect(() => {
    const getHouseSensors = async () => {
      let houseSensors = await houseSensorService.listHouseSensors();

      // houseSensors = houseSensors.map((sensor) => ({
      //   name: sensor.sensor_name,
      //   type: sensor.sensor_type
      // }))
      // 내림차순 정렬
      houseSensors = houseSensors.map((sensor) => ({
        name: sensor.sensor_name,
        type: sensor.sensor_type,
      })).sort((a, b) => (a.name < b.name ? 1 : -1));

      const currentMenu = cloneDeep(find(menuList, (menu) => currentPath.includes(menu.path)));
      currentMenu.dep2[0].dep3[0].dep4 = houseSensors

      updateCurrentMenu((draft) => {
        draft.currentMenu = currentMenu
      })

      if (currentPath.startsWith('/house/sensor')) {
        navigate(`/house/sensor?type=${houseSensors[0].type}`, { replace: true });
      }

      setLoading(false);
    };

    const getContainerSensors = async () => {
      let containerSensors = await containerSensorService.listContainerSensors();

      containerSensors = containerSensors.map((sensor) => ({
        name: sensor.sensor_name,
        type: sensor.sensor_type
      })).sort((a, b) => (a.name < b.name ? 1 : -1));

      const currentMenu = cloneDeep(find(menuList, (menu) => currentPath.includes(menu.path)));
      currentMenu.dep2[0].dep3[0].dep4 = containerSensors

      updateCurrentMenu((draft) => {
        draft.currentMenu = currentMenu
      })

      if (currentPath.startsWith('/container/sensor')) {
        navigate(`/container/sensor?type=${containerSensors[0].type}`, { replace: true });
      }

      setLoading(false);
    }

    const getOutdoorWeatherStations = async () => {
      let weatherStations = await outdoorWeatherStationService.listWeatherStations();

      weatherStations = weatherStations.map((sensor) => ({
        name: sensor.sensor_name,
        type: sensor.sensor_type
      }));

      const currentMenu = cloneDeep(find(menuList, (menu) => currentPath.includes(menu.path)));

      currentMenu.dep2[0].dep3 = weatherStations

      updateCurrentMenu((draft) => {
        draft.currentMenu = currentMenu
      })

      if (currentPath.startsWith('/outdoor')) {
        navigate(`/outdoor?type=${weatherStations[0].type}`, { replace: true });
      }

      setLoading(false);
    }

    const getContainerCorridorPowermeterSersors = async () => {
      let sensors = await containerCorridorService.listPowermeterSensors();

      sensors = sensors.map((sensor) => ({
        name: sensor.sensor_name,
        type: sensor.sensor_type
      })).sort((a, b) => (a.name < b.name ? 1 : -1));

      const currentMenu = cloneDeep(find(menuList, (menu) => currentPath.includes(menu.path)));
      currentMenu.dep2[0].dep3[2].dep4 = sensors

      updateCurrentMenu((draft) => {
        draft.currentMenu = currentMenu
      })

      if (currentPath.startsWith('/container/power')) {
        navigate(`/container/power?type=${sensors[0].type}`, { replace: true });
      }

      setLoading(false);
    }

    const getHouseCorridorPowermeterSersors = async () => {
      let sensors = await houseCorridorService.listPowermeterSensors();

      sensors = sensors.map((sensor) => ({
        name: sensor.sensor_name,
        type: sensor.sensor_type
      })).sort((a, b) => (a.name < b.name ? 1 : -1));

      const currentMenu = cloneDeep(find(menuList, (menu) => currentPath.includes(menu.path)));
      currentMenu.dep2[0].dep3[2].dep4 = sensors

      updateCurrentMenu((draft) => {
        draft.currentMenu = currentMenu
      })
      
      if (currentPath.startsWith('/house/power')) {
        navigate(`/house/power?type=${sensors[0].type}`, { replace: true });
      }

      setLoading(false);
    }

    const getOutdoorWeatherKorea = async () => {
      let weatherKorea = await outdoorWeatherKoreaService.listWeatherKorea();
      
      weatherKorea = weatherKorea.map((sensor) => ({
        name: sensor.sensor_name,
        type: sensor.sensor_type
      })).sort((a, b) => (a.name < b.name ? 1 : -1));;

      const currentMenu = cloneDeep(find(menuList, (menu) => currentPath.includes(menu.path)));

      // currentMenu.dep2[0].dep3 = weatherKorea

      updateCurrentMenu((draft) => {
        draft.currentMenu = currentMenu
      })

      if (currentPath.startsWith('/kma')) {
        navigate(`/kma?type=${currentMenu.dep2[0].dep3[0].type}`, { replace: true });
      }

      setLoading(false);
    }

    if (currentPath.startsWith('/house/sensor')) {
      setLoading(true);
      getHouseSensors();
    } else if (currentPath.startsWith('/container/sensor')) {
      setLoading(true);
      getContainerSensors();
    }  else if (currentPath.startsWith('/outdoor')) {
      setLoading(true);
      getOutdoorWeatherStations();
    } else if (currentPath.startsWith('/container/power')) {
      setLoading(true);
      getContainerCorridorPowermeterSersors();
    } else if (currentPath.startsWith('/house/power')) {
      setLoading(true);
      getHouseCorridorPowermeterSersors();
    } else if (currentPath.startsWith('/kma')) {
      setLoading(true);
      getOutdoorWeatherKorea();
    }  else {
      updateCurrentMenu((draft) => {
        draft.currentMenu = menuList.find((menu) => currentPath.includes(menu.path))
      })
    }
  }, [currentPath])

  return (
    <S.SideWrap>
      <S.Nav>
        <H2 $display="none">네비게이션 메뉴</H2>
        <div className="logoBox">
          <Icon name="Logo" $margin="auto" />
        </div>
        <Line $margin="24px 0" />
        <ul>
          {menuList.map((menu) => (
            <li key={`menu_${menu.id}`}>
              <S.MenuLink $active={currentPath.includes(menu.path)} to={menu.path}>
                <S.IconDiv className="box">
                  <Icon name={menu.name} $pathFill={currentPath.includes(menu.path) && 'primary600'} />
                </S.IconDiv>
                <H3 $color={currentPath.includes(menu.path) && 'primary600'} $type="m16" $textAlign="center">
                  {menu.name}
                </H3>
              </S.MenuLink>
            </li>
          ))}
        </ul>
      </S.Nav>
      <S.SubBox>
        { loading && (
          <CenterRowDiv $justifyContent="center" $padding="10px">
            <Spinner $width={25} $height={25}/>
          </CenterRowDiv>
        )}
        { !loading && (
          <>
            <S.LabelDiv>
              <Icon name={currentMenuData.currentMenu.name} />
              <Text $type="b24">{currentMenuData.currentMenu.name}</Text>
            </S.LabelDiv>
            {currentMenuData.currentMenu?.dep2?.map((dep2, index) => (
              <React.Fragment key={`dep2_${index}`}>
                <S.Dep2Div onClick={() => toggleDep2(index)}>
                  <Text $color="supportive" $type="b">
                    {dep2.name}
                  </Text>
                  {dep2.dep3 && <Icon name="Arrow" $transform={openDeps.dep2 === index && 'rotate(-180deg)'} />}
                </S.Dep2Div>
                {openDeps.dep2 === index && (
                  <ul>
                    {dep2?.dep3.map((dep3, dep3Idx) => (
                      <li key={`dep3_${dep3Idx}`}>
                        <S.Dep3Link
                          onClick={() => toggleDep3(dep3Idx, dep3)}
                          to={
                            dep3.dep4
                              ? `${currentMenuData.currentMenu.path}/${dep3.path}`
                              : dep3.path
                                ? `${currentMenuData.currentMenu.path}/${dep3.path}${dep3.type ? `?type=${dep3.type}` : ''}`
                                : `${currentMenuData.currentMenu.path}${dep3.type ? `?type=${dep3.type}` : ''}`
                          }
                        >
                          <Text
                            $type={
                              openDeps.dep3 === dep3Idx || currentPath.includes(`${currentMenuData.currentMenu.path}/${dep3.path}`)
                                ? 'b16'
                                : 'm16'
                            }
                            $color={
                              openDeps.dep3 === dep3Idx || currentPath.includes(`${currentMenuData.currentMenu.path}/${dep3.path}`)
                                ? 'primary800'
                                : 'default'
                            }
                          >
                            {dep3.name}
                          </Text>
                          {dep3.dep4 && (
                            <Icon
                              name="Arrow"
                              $transform={openDeps.dep3 === dep3Idx && 'rotate(-180deg)'}
                              $pathFill={openDeps.dep3 === dep3Idx && 'primary800'}
                              $pathOpacity={openDeps.dep3 === dep3Idx && '1'}
                            />
                          )}
                        </S.Dep3Link>
                        {openDeps.dep3 === dep3Idx && dep3.dep4 && (
                          <S.ScrollList>
                            {dep3.dep4.map((dep4, dep4Idx) => (
                              <li key={`dep4_${dep4Idx}`}>
                                <S.Dep4Link
                                  to={`${currentMenuData.currentMenu.path}/${dep3.path}${dep4.type ? `?type=${dep4.type}` : ''}`}
                                  $active={
                                    `${currentPath}${location.search}` ===
                                    `/${currentMenuData.currentMenu.path}/${dep3.path}${dep4.type ? `?type=${dep4.type}` : ''}`
                                  }
                                >
                                  <Text
                                    $type={
                                      `${currentPath}${location.search}` ===
                                      `/${currentMenuData.currentMenu.path}/${dep3.path}${dep4.type ? `?type=${dep4.type}` : ''}`
                                        ? 'm16'
                                        : '16'
                                    }
                                    $color={
                                      `${currentPath}${location.search}` ===
                                      `/${currentMenuData.currentMenu.path}/${dep3.path}?type=${dep4.type}`
                                        ? 'primary900'
                                        : 'default'
                                    }
                                  >
                                    {dep4.name}
                                  </Text>
                                </S.Dep4Link>
                              </li>
                            ))}
                          </S.ScrollList>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </React.Fragment>
            ))}
          </>
        )}
      </S.SubBox>
    </S.SideWrap>
  );
}
